import { type IEntitiesStore } from 'entities/EntitiesExport'

export const unifiedAgentEvent =
  <TData extends Record<string, unknown> = Record<string, unknown>>(event: string) =>
  (entities: IEntitiesStore, data?: TData) => {
    entities.eventLogStore.logEvent(
      event,
      { event_id: event.toLowerCase(), userId: entities.usersStore.user_owner_id, ...data },
      { groupId: entities.organizationStore.id }
    )
  }
